import {cloneDeep as _cloneDeep} from 'lodash';
import DynpropsModel from "@/models/DynpropsModel"
const DynpropsModule = {
    namespaced: true,
    state: () => ({
        dynprops: _cloneDeep(DynpropsModel),
    }),
    getters: {
        getDynprops(state) {
            return state.dynprops
        },
    },
    mutations: {
        setDynprops(state, payload) {
            state.dynprops = payload
        },
    },
    actions: {
        setDynprops(context, payload) {
            context.commit('setDynprops', payload);
        },
    },
}

export default DynpropsModule;
